import { render, staticRenderFns } from "./eventTaskDetail.vue?vue&type=template&id=dd2e1b4a&scoped=true&"
import script from "./eventTaskDetail.vue?vue&type=script&lang=js&"
export * from "./eventTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./eventTaskDetail.vue?vue&type=style&index=0&id=dd2e1b4a&prod&lang=scss&"
import style1 from "./eventTaskDetail.vue?vue&type=style&index=1&id=dd2e1b4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2e1b4a",
  null
  
)

export default component.exports